import { createTheme } from '@mui/material/styles';

// Dark theme (nouvelle) colors
export const darkBg = 'rgb(15, 20, 22)';
export const darkTxt = 'rgb(222, 227, 230)';
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(134, 209, 234)',
      contrastText: 'rgb(0, 54, 66)',
    },
    secondary: {
      main: 'rgb(179, 202, 212)',
      contrastText: 'rgb(29, 52, 59)',
    },
    tertiary: {
      main: 'rgb(193, 196, 235)',
      contrastText: 'rgb(42, 46, 77)',
    },
    error: {
      main: 'rgb(255, 180, 171)',
      contrastText: 'rgb(105, 0, 5)',
    },
    background: {
      default: 'rgb(15, 20, 22)',
      paper: 'rgb(15, 20, 22)',
    },
    surface: {
      main: 'rgb(15, 20, 22)',
      variant: 'rgb(64, 72, 75)',
      dim: 'rgb(15, 20, 22)',
      bright: 'rgb(52, 58, 60)',
      container: 'rgb(27, 32, 35)',
      containerLow: 'rgb(23, 28, 30)',
      containerHigh: 'rgb(37, 43, 45)',
    },
    text: {
      primary: 'rgb(222, 227, 230)',
      secondary: 'rgb(191, 200, 204)',
      disabled: 'rgb(137, 146, 150)',
      hint: 'rgb(191, 200, 204)',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
  },
  overrides: {
    MuiButton: {
      // Add button overrides if needed
    },
    // Add more overrides as needed
  },
});

// Light theme (nouvelle) colors
export const lightBg = 'rgb(245, 250, 253)';
export const lightTxt = 'rgb(23, 28, 30)';
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(1, 103, 125)',
      contrastText: 'rgb(255, 255, 255)',
    },
    secondary: {
      main: 'rgb(75, 98, 106)',
      contrastText: 'rgb(255, 255, 255)',
    },
    tertiary: {
      main: 'rgb(89, 92, 126)',
      contrastText: 'rgb(255, 255, 255)',
    },
    error: {
      main: 'rgb(186, 26, 26)',
      contrastText: 'rgb(255, 255, 255)',
    },
    background: {
      default: 'rgb(245, 250, 253)',
      paper: 'rgb(245, 250, 253)',
    },
    surface: {
      main: 'rgb(245, 250, 253)',
      variant: 'rgb(219, 228, 232)',
      dim: 'rgb(214, 219, 221)',
      bright: 'rgb(245, 250, 253)',
      container: 'rgb(234, 239, 241)',
      containerLow: 'rgb(239, 244, 247)',
      containerHigh: 'rgb(228, 233, 235)',
    },
    text: {
      primary: 'rgb(23, 28, 30)',
      secondary: 'rgb(64, 72, 75)',
      disabled: 'rgb(112, 120, 124)',
      hint: 'rgb(191, 200, 204)',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
  },
  overrides: {
    MuiButton: {
      // Add button overrides if needed
    },
    // Add more overrides as needed
  },
});
